// Custom SVG Icons — auto-generiert von scripts/fetch-svg.ts
// <MIcon icon="name" /> nutzt zuerst diese Map, dann MDI Icons.

export const customIconPaths: Record<string, string> = {}

export const customIconFiles: Record<string, string> = {}
